import React from 'react';
import { GameState, DisplayFixture } from '../../domain/entities';
import { View } from '../../App';
import { findTeamInState } from '../../services/GameService';
import { TeamScreen } from './TeamScreen';
import { TeamFixtures } from '../shared/TeamFixtures';

interface TeamDetailScreenProps {
    gameState: GameState;
    pushView: (view: View) => void;
    teamName: string;
    activeTab?: 'list' | 'depth' | 'fixtures';
    updateCurrentView: (propsToUpdate: Partial<View>) => void;
    adsEnabled: boolean;
    isAiPunditEnabled: boolean;
    showRatingsOnMatchReport: boolean;
    showHiddenInfo?: boolean;
    // FIX: Removed props that are no longer needed by TeamScreen.
    onCacheAiMatchReport: (fixture: DisplayFixture, report: { title: string; message: string; }) => void;
}

export const TeamDetailScreen: React.FC<TeamDetailScreenProps> = ({ gameState, pushView, teamName, activeTab, updateCurrentView, adsEnabled, isAiPunditEnabled, showRatingsOnMatchReport, showHiddenInfo, onCacheAiMatchReport }) => {
    const teamData = findTeamInState(gameState, teamName);

    if (!teamData) {
        return <div className="panel"><div className="panel-content">Team not found: {teamName}</div></div>;
    }

    const { team, leagueName } = teamData;
    const league = gameState.leagues[leagueName];
    if (!league) {
         return <div className="panel"><div className="panel-content">League not found for team: {teamName}</div></div>;
    }

    const allPlayersInLeague = league.teams.flatMap(t => t.squad);
    const leagueAverageSkill = allPlayersInLeague.length > 0
        ? allPlayersInLeague.reduce((sum, p) => sum + p.skill, 0) / allPlayersInLeague.length
        : 50;
        
    const isPlayerTeam = teamName === gameState.playerTeamName;

    const noOpFunc = async () => ({ success: false, message: 'This action is not available for AI-controlled teams.'});

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <TeamScreen
                team={team}
                leagueAverageSkill={leagueAverageSkill}
                season={gameState.season}
                gameState={gameState}
                pushView={pushView}
                updateCurrentView={updateCurrentView}
                activeTab={activeTab}
                adsEnabled={adsEnabled}
                isAiPunditEnabled={isAiPunditEnabled}
                showRatingsOnMatchReport={showRatingsOnMatchReport}
                showHiddenInfo={showHiddenInfo}
                isPlayerTeam={isPlayerTeam}
                onPlayerConversation={noOpFunc as any}
                onOfferFinancialIncentive={noOpFunc as any}
                onCacheAiMatchReport={onCacheAiMatchReport}
            />
        </div>
    );
};
